((function(){
    'use strict';

    const checkForAppBlock = () => {
        const appBlockEl = document.querySelector('div[id*="joy_loyalty_program_joy_points_calculator_block"] .Avada-PointsCalculator__Container');
        const jpcEl = document.querySelector('[data-adev-jpc-wrapper]');
        const jpcTextEl = document.querySelector('[data-adev-jpc-text]');

        if (appBlockEl) {
            jpcEl.classList.add('active');
            let text = appBlockEl.innerText;
            
            text = text.replace('.', '. ');
            text = text.replace(/Earn\s+(\d+)\s+rewards\s+points/, 'Earn <strong>$1 rewards points</strong>');

            jpcTextEl.innerHTML = text;
        } else {
            setTimeout(checkForAppBlock, 100);
        }
    }
    
    checkForAppBlock();
    
})());